"use strict";
define(
'stores/stats',[
    "stores/store",
    "actions/badges",
    "constants/actiontypes"
],
function (StoreBase, Action, Constants)
{
    Store.prototype = new StoreBase();
    Store.constructor = Store;

    function Store (params)
    {
        // Call parent constructor
        StoreBase.call(this, params);

        // Setup the instance
        this.stats = {};

        this.registerDispatchListener(function (action) {
            switch(action.actionType) {
                case Constants.ADD_STATS:
                    this.addStats(action.data);
                    
                    this.event.emit("change");
                    break;
            }
        }.bind(this));

        this.action = new Action();
    }

    Store.prototype.addStats = function(stats) {
        this.stats = stats;
    };

    Store.prototype.getStat = function(stat_name) {
        if(!stat_name in this.stats){
            return 0;
        }
        return this.stats[stat_name];
    }; 

    return Store;
});
